/**
 * Shop All mega menu: title case labels, collection → image map,
 * hover/focus updates featured image + link, preload for instant swaps.
 */
(function () {
  var DEFAULT_IMG =
    "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Face_4adfa7b5-4042-4593-9d51-6f1210d74fe5.png?v=1775042900";

  var IMAGE_BY_PATH = {
    "/collections/serum-skin-tint":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/IMG_5019_1.png?v=1779911345",
    "/collections/face": DEFAULT_IMG,
    "/collections/cheeks":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Cheeks_31d09440-a7b4-4362-aaab-84e7aab04ad7.png?v=1775042899",
    "/collections/eyes":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Eyes_b0922b89-31b0-416a-97bf-31c9a0c381f4.png?v=1775042900",
    "/collections/lips":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Lips_1d3478cf-6862-4747-a07d-9fc277955c9b.png?v=1775042900",
    "/collections/tools":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Tools_15418c7e-2a39-4709-a416-d52595243079.png?v=1775042899",
    "/collections/sample-sets":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/SAMPLE_SET.png?v=1775042899",
    "/collections/lip-oil-sticks":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/LIP_OIL_STICK.png?v=1775042899",
    "/collections/tints":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/HYDRA_JELLY_TINTS.png?v=1775042900",
    "/collections/concealers":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/CONCEALERS.png?v=1775042899",
    "/collections/mini-foundation":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/MINI_FOUNDATIONS.png?v=1775042900",
    "/collections/foundations":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/FOUNDATIONS.png?v=1775042900",
    "/collections/primers":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/PRIMERS.png?v=1775042900",
    "/collections/setting-spray":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/SETTING_SPRAYS.png?v=1775042900",
    "/collections/smudge-sticks":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/SMUDGE_STICKS.png?v=1775042900",
    "/collections/dual-smudge-sticks":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/DUAL_SMUDGE_STICKS.png?v=1775042900",
    "/collections/lipsticks":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/LIPSTICKS.png?v=1775042899",
    "/collections/lip-shimmers":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/LIP_LUSTRE_a00fc99e-23d2-453b-ad1f-f619a9b05767.png?v=1775042899",
    "/collections/eyeshadows":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/EYESHADOWS_37ff0a49-eadf-41b7-8933-63201a05fb70.png?v=1781204176",
    "/collections/oily-and-acne-prone-skin":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Oily_Acne_Prone_skin.png?v=1775042900",
    "/collections/fine-lines-and-wrinkles":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Fine_Lines_Wrinkles.png?v=1775042900",
    "/collections/dark-spots-and-dullness":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Dark_Spots_Dullness_6e07c4a4-97e5-473f-856e-3421894b353a.png?v=1781204194",
    "/collections/sensitive-skin-and-redness":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Sensitive_skin_redness.png?v=1775042899",
    "/collections/dry-and-dehydrated-lips":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Dry_and_dehydrated_lips_0442652e-18f6-4314-ba75-9f0f5fc24381.png?v=1781204235",
    "/collections/pigmented-lips":
      "https://cdn.shopify.com/s/files/1/0555/4018/7214/files/Pigmented_lips.png?v=1775042899",
  };

  function normPath(href) {
    try {
      var p = new URL(href, window.location.origin).pathname;
      if (p.length > 1 && p.slice(-1) === "/") return p.slice(0, -1);
      return p;
    } catch (e) {
      return "";
    }
  }

  function imageUrlForHref(href) {
    var p = normPath(href);
    return IMAGE_BY_PATH[p] || DEFAULT_IMG;
  }

  function titleCase(s) {
    var t = (s || "").replace(/\s+/g, " ").trim();
    if (!t) return "";
    return t.toLowerCase().replace(/\b[a-z]/g, function (c) {
      return c.toUpperCase();
    });
  }

  function preloadAll() {
    var seen = {};
    function add(u) {
      if (!u || seen[u]) return;
      seen[u] = true;
      var img = new Image();
      img.src = u;
    }
    add(DEFAULT_IMG);
    Object.keys(IMAGE_BY_PATH).forEach(function (k) {
      add(IMAGE_BY_PATH[k]);
    });
  }

  var megaObserver = null;

  function initShopAllMega() {
    var root = document.querySelector(".shop-all-mega");
    if (!root) return;

    var megaImg = root.querySelector("[data-shop-all-image]");
    var megaLink = root.querySelector("[data-shop-all-image-link]");
    if (!megaImg || !megaLink) return;

    root.querySelectorAll(".shop-all-mega__heading, .shop-all-mega__link").forEach(function (el) {
      var tc = titleCase(el.textContent);
      if (tc) el.textContent = tc;
    });

    if (megaObserver) {
      megaObserver.disconnect();
      megaObserver = null;
    }

    function fadeOut() {
      megaImg.classList.add("is-fading");
    }
    function fadeIn() {
      megaImg.classList.remove("is-fading");
    }

    megaObserver = new MutationObserver(function () {
      var src = megaImg.getAttribute("src");
      if (!src) return;
      if (megaImg.getAttribute("data-shop-all-skip-fade") === "1") {
        megaImg.removeAttribute("data-shop-all-skip-fade");
        return;
      }
      fadeOut();
      var pre = new Image();
      pre.src = src;
      if (megaImg.complete && megaImg.naturalWidth > 0) {
        requestAnimationFrame(fadeIn);
      } else {
        megaImg.addEventListener(
          "load",
          function () {
            requestAnimationFrame(fadeIn);
          },
          { once: true }
        );
      }
    });
    megaObserver.observe(megaImg, { attributes: true, attributeFilter: ["src"] });

    function onItemActivate(anchor) {
      if (!anchor || !anchor.href) return;
      var url = imageUrlForHref(anchor.href);
      megaLink.setAttribute("href", anchor.href);
      megaImg.setAttribute("data-shop-all-skip-fade", "1");
      megaImg.src = url;
    }

    root.querySelectorAll("[data-shop-all-link]").forEach(function (a) {
      if (a.getAttribute("data-shop-all-bound") === "1") return;
      a.setAttribute("data-shop-all-bound", "1");
      a.addEventListener(
        "mouseenter",
        function () {
          onItemActivate(a);
        },
        { passive: true }
      );
      a.addEventListener("focusin", function () {
        onItemActivate(a);
      });
    });

    preloadAll();
  }

  function boot() {
    initShopAllMega();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(".shop-all-mega")) {
      initShopAllMega();
    }
  });
})();
